document.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowRight') {
      const nextBtn = document.querySelector('.slider-button--next');
      if (nextBtn) nextBtn.click();
    } else if (event.key === 'ArrowLeft') {
      const prevBtn = document.querySelector('.slider-button--prev');
      if (prevBtn) prevBtn.click();
    }
  });